// +----------------------------------------------------------------------
// | ThisAdmin [ ThisAdmin赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2022 https://www.thisadmin.cn All rights reserved.
// +----------------------------------------------------------------------
// | Licensed ThisAdmin并不是自由软件，未经许可不能去掉ThisAdmin相关版权
// +----------------------------------------------------------------------
// | Author: ThisAdmin Team   Email: oszzw@qq.com
// +----------------------------------------------------------------------

import {createRouter, createWebHistory} from 'vue-router'
// 路由数据
import routes from './routes';
//应用配置
import siteInfo from '/siteInfo';
//引入store
import store from '@/store/index.js';

//console.log(siteInfo)
//console.log(routes)

const router = createRouter({
  history: createWebHistory('/'+siteInfo.site_dist),
  routes,
  /*scrollBehavior (to, from, savedPosition) {
    console.log(to+'；'+from+'；'+savedPosition);
    return { x: 0, y: 0 }
  }*/
})
/*全局的前置钩子函数，路由切换开始时调用 监听路由变化*/
router.beforeEach((to, _from, next) => {
  // 获取登录状态和会员信息
  const isLogin = store.getters['auth/isLogin'];
  const memberType = store.getters['auth/memberType'];
  const hasPaid = store.getters['auth/hasPaid'];
  const isDirector = store.getters['auth/isDirector'];
  const isApproved = store.getters['auth/isApproved'];
  
  // 检查是否需要登录
  if (to.meta.requiresAuth && !isLogin) {
    // 需要登录但未登录，跳转到登录
    next('/login');
    return;
  }
  
  // 检查是否需要选择会员类型
  if (to.meta.requiresMemberType && !memberType) {
    next('/user/member-type-select');
    return;
  }
  
  // 检查是否需要已支付（如果需要支付但没有会员类型，先去选择会员类型）
  if (to.meta.requiresPaid) {
    if (!memberType) {
      next('/user/member-type-select');
      return;
    }
    if (!hasPaid) {
      next('/user/member-payment');
      return;
    }
  }
  
  // 检查是否需要审核通过
  if (to.meta.requiresApproved && !isApproved) {
    next('/user/home');
    return;
  }
  
  // 检查是否需要理事权限
  if (to.meta.requiresDirector && !isDirector) {
    // 不是理事会员，提示并返回
    if (isLogin) {
      // 已登录但不是理事
      next('/user/home');
    } else {
      next('/user/member-register');
    }
    return;
  }

  next();
})
/*全局后置钩子函数，路由切换成功进入激活阶段*/
router.afterEach(to => {
  // 页面标题
  window.document.title = to.meta.title + ' - 协会用户门户';
  // 滚动到页面顶部
  window.scrollTo(0, 0);
});

export default router
